<script setup>
import { defineProps, ref } from 'vue';
import {DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem} from "@/shadcn/components/ui/dropdown-menu";
import Avatar from "@/components/ui/Avatar.vue";
import FuseSearchInput from "@/components/atoms/fuse-search/FuseSearchInput.vue";
import FuseSearch from "@/components/atoms/fuse-search/FuseSearch.vue";

const props = defineProps({
  focus: {
    type: Boolean,
    default: false,
  },
  exponents : {
    type: Array,
    default: [],
  },
  destroyUrl: {
    type: String,
    default: null,
  },
})


const deleteForm = ref(null);

const csrfToken = window.Laravel.csrfToken;

const deleteGroup = (exponentId) => {
  if (!props.destroyUrl) {
    return;
  }
  deleteForm.value.action = props.destroyUrl.replace(':exponent', exponentId);
  deleteForm.value.submit();
}

</script>

<template>
  <FuseSearch
    :data="exponents"
    :model-value="exponents"
    :keys="['name', 'brands.name']"
    :exact-match-number="0.2"
  >
    <template #search="{ modelValue, updateModelValue }">
      <div class="my-3">
        <FuseSearchInput
          :modelValue="modelValue"
          @update:modelValue="updateModelValue"
          class="form-control form-control-lg"
        />
      </div>
    </template>
    <template #default="{ results }">
        <div class="card">
            <ul class="list-group list-group-flush">
                <li class="list-group-item tw:group/item tw:relative tw:hover:bg-zinc-100 tw:flex tw:items-center tw:justify-between tw:gap-3 tw:lg:gap-6 " v-for="exponent in results" :key="exponent.id">
                    <div>
                      <a :href="exponent.links.show">
                        <Avatar :size="50" :username="exponent.name"></Avatar>
                      </a>
                    </div>
                    <div class="flex-grow-1">
                        <a :href="exponent.links.show">
                            <strong>{{ exponent.name }}</strong>
                        </a>
                        <span v-if="exponent.as_guest" class="badge badge-pill badge-secondary ml-2">Guest</span>
                        <br/>
                        <small v-for="brand in exponent.brands">
                            <a :href="brand.links.products">{{ brand.name }}</a> /
                        </small>
                    </div>

                    <div class="d-none d-sm-block text-center" v-if="!isNaN(exponent.products_count)">
                        <p class="mb-0">
                            <small class="text-muted tw:uppercase">{{ $t('Models') }}</small><br>
                            <strong>{{ exponent.products_count }}</strong>
                        </p>
                    </div>
                    <div class="d-none d-sm-block text-center" v-if="!isNaN(exponent.equipments_count)">
                        <p class="mb-0">
                            <small class="text-muted tw:uppercase">{{ $t('Items') }}</small><br>
                            <strong>{{ exponent.equipments_count }}</strong>
                        </p>
                    </div>
                  <div class="d-none d-sm-block text-center">
                    <p class="mb-0">
                      <small class="text-muted tw:uppercase">{{ $t('Parks') }}</small><br>
                      <strong>{{ exponent.brands?.reduce((total, brand) => total + brand.parks_count, 0) ?? 'N/A' }}</strong>
                    </p>
                  </div>
                  <div class="text-center" v-if="destroyUrl">
                      <DropdownMenu>
                          <DropdownMenuTrigger class="btn btn-link">
                              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                          </DropdownMenuTrigger>
                          <DropdownMenuContent align="end">
                              <button @click="deleteGroup(exponent.id)" class="text-danger tw:block tw:w-full">
                                  <DropdownMenuItem>{{ $t('Detach') }}</DropdownMenuItem>
                              </button>
                          </DropdownMenuContent>
                      </DropdownMenu>
                  </div>
                </li>
            </ul>
        </div>
        <form action="" ref="deleteForm" method="post">
          <input type="hidden" name="_method" value="DELETE">
          <input type="hidden" name="_token" :value="csrfToken">
        </form>
    </template>
  </FuseSearch>
</template>
